// Mandatory legal disclaimer banner — sits above the catalogue on
// every render (authed + anonymous). Copy is verbatim per legal:
// research-only, not for human consumption, all sales final, no
// returns/refunds. Treated with high contrast so it cannot be
// missed — amber-on-warmblack with a mono accent strip.
import { C } from "@/lib/brand";

const RESEARCH_AMBER = "#E8C66B";
const RESEARCH_AMBER_DEEP = "#A07A1F";

export default function ResearchLegalNotice() {
  return (
    <section
      data-testid="research-legal-notice"
      style={{
        background: C.warmBlack,
        color: C.cream,
        padding: "32px 24px",
        borderTop: `4px solid ${RESEARCH_AMBER}`,
      }}
    >
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
            marginBottom: 16,
            fontFamily: '"JetBrains Mono", "IBM Plex Mono", ui-monospace, monospace',
            fontSize: 10,
            letterSpacing: "0.3em",
            color: RESEARCH_AMBER,
            textTransform: "uppercase",
          }}
        >
          <span aria-hidden style={{ width: 24, height: 1, background: RESEARCH_AMBER }} />
          <span>▪ IMPORTANT NOTICE</span>
        </div>
        <p
          data-testid="research-legal-notice-paragraph-1"
          style={{
            margin: 0,
            fontSize: 14,
            lineHeight: 1.65,
            color: C.cream,
            maxWidth: 880,
          }}
        >
          Please note all products listed here are intended for research purposes only
          and are not for human consumption. They are
          {" "}
          <strong style={{ color: RESEARCH_AMBER, fontWeight: 800 }}>NOT</strong>
          {" "}
          approved for clinical, therapeutic, or diagnostic applications.
        </p>
        <p
          data-testid="research-legal-notice-paragraph-2"
          style={{
            margin: "14px 0 0 0",
            fontSize: 14,
            lineHeight: 1.65,
            color: C.cream,
            maxWidth: 880,
          }}
        >
          <strong style={{ color: RESEARCH_AMBER, fontWeight: 800 }}>ALL sales are FINAL.</strong>
          {" "}
          Returns or refunds are
          {" "}
          <strong style={{ color: RESEARCH_AMBER, fontWeight: 800 }}>NOT</strong>
          {" "}
          available for research products.
        </p>
      </div>
    </section>
  );
}

export { RESEARCH_AMBER, RESEARCH_AMBER_DEEP };
